module.exports = __webpack_public_path__ + "img/symbol_2.80da85c3.png";